import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import globalClasses from '../../App.css';
import Aux from '../../hoc/Aux/Aux';
import classes from './PersonalDataForm.css';
import Footer from '../../components/UI/Footer/Footer';
import Input from '../../components/UI/Input/Input'
import SquaredCheckbox from '../../components/UI/Checkbox/SquaredCheckbox/SquaredCheckbox';
import { personalDataSetFields, bookingProcessSetStep } from '../../store/actions/bookingProcess';
import { startBookingConfirmationProcess } from '../../store/actions/bookingConfirmation';
import { BOOKING_STEPS } from '../../constants';
import { parseDateToReadable } from '../../utils';

import intlPhone from 'intl-tel-input';

//eslint-disable-next-line
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const NUM_REGEX = /^[0-9]+$/;

class PersonalDataForm extends Component {
  state = {
    form: {
      name: {
        label: this.props.translations.label_name,
        elementType: 'input',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translations.label_placeholder_name
        },
        value: this.props.name || '',
        validation: {
          required: true,
          type: 'name'
        },
        valid: false,
        touched: false,
        isOnFocus: false
      },
      surname: {
        label: this.props.translations.label_surname,
        elementType: 'input',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translations.label_placeholder_surname
        },
        value: this.props.surname || '',
        validation: {
          required: true,
          type: 'surname'
        },
        valid: false,
        touched: false,
        isOnFocus: false
      },
      email: {
        label: this.props.translations.label_email,
        elementType: 'input',
        elementConfig: {
          type: 'email',
          placeholder: this.props.translations.label_placeholder_email
        },
        value: this.props.email || '',
        validation: {
          required: true,
          type: 'email'
        },
        valid: false,
        touched: false,
        isOnFocus: false
      },
      phone: {
        label: this.props.translations.label_phone,
        elementType: 'input',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translations.label_placeholder_phone
        },
        value: this.props.mobilePhone || '',
        validation: {
          required: true,
          type: 'number'
        },
        valid: false,
        touched: false,
        isOnFocus: false
      },
    },
    mobilePhoneCountryData: this.props.mobilePhoneCountryData,
    hasAcceptedMarketing: localStorage.getItem('acceptedMarketing') === "true" ? true : false,
    specialRequests: this.props.specialRequests,
  }

  inputPhoneReference = null;
  phoneHandlerReference = null;

  handleCountryChange = e => {
    const country = this.phoneHandlerReference.getSelectedCountryData();
    this.setState({ mobilePhoneCountryData: country });
  }

  componentDidMount() {
    this.phoneHandlerReference = intlPhone(
      this.inputPhoneReference,
      {
        initialCountry: this.props.mobilePhoneCountryData.iso2 || 'it'
      }
    );
    this.inputPhoneReference.addEventListener('countrychange', this.handleCountryChange);
  }

  componentWillUnmount() {
    this.inputPhoneReference.removeEventListener('countrychange', this.handleCountryChange);
  }

  continueHandler = () => {
    this.props.setPersonalDataFields({
      email: this.state.form.email.value,
      mobilePhone: this.state.form.phone.value,
      name: this.state.form.name.value,
      surname: this.state.form.surname.value,
      mobilePhoneCountryData: this.state.mobilePhoneCountryData,
      hasAcceptedEmailMarketing: this.state.hasAcceptedMarketing,
      specialRequests: this.state.specialRequests,
    });

    this.props.startBookingConfirmationProcess();
  }

  backHandler = () => {
    this.props.history.goBack();
  }

  checkValidity(value, rules) {
    let isValid = [];

    if (rules.required) {
      isValid.push(value.trim() !== '');
    }

    if (rules.minLength) {
      isValid.push(value.length >= rules.minLength);
    }

    if (rules.maxLength) {
      isValid.push(value.length <= rules.maxLength);
    }

    if (rules.type && rules.type === 'email') {
      isValid.push(EMAIL_REGEX.test(value));
    }

    if (rules.type && rules.type === 'number') {
      isValid.push(NUM_REGEX.test(value));
    }

    return isValid.indexOf(false) > -1 ? false : true;
  }

  checkValidatyAllForm() {
    let isValid = true;
    const invalidFields = [];
    if (!this.state.form.name.value || this.state.form.name.value.length <= 1) {
      isValid = false;
      invalidFields.push('name');
    }
    if (!this.state.form.surname.value || this.state.form.surname.value.length <= 1) {
      isValid = false;
      invalidFields.push('surname');
    }
    if (!this.state.form.email.value || !EMAIL_REGEX.test(this.state.form.email.value)) {
      isValid = false;
      invalidFields.push('email');
    }
    if (!this.state.form.phone.value || !NUM_REGEX.test(this.state.form.phone.value)) {
      isValid = false;
      invalidFields.push('phone');
    }

    return { isValid, invalidFields }
  }

  checkFocus(el) {
    return el === document.activeElement
  }

  inputChangeHandler = (event, inputIdentifier) => {
    const updatedForm = {
      ...this.state.form
    }
    // create a deep clone of the form element
    const updatedFormElement = { ...updatedForm[inputIdentifier] }
    updatedFormElement.value = event.target.value;
    updatedFormElement.valid = this.checkValidity(updatedFormElement.value, updatedFormElement.validation)
    updatedFormElement.isOnFocus = this.checkFocus(event.target)
    updatedFormElement.touched = true;
    updatedForm[inputIdentifier] = updatedFormElement;
    this.setState({ form: updatedForm })
  }

  render() {
    const formElementArray = [];
    for (let key in this.state.form) {
      formElementArray.push({
        id: key,
        config: this.state.form[key]
      })
    }
    let form = (
      <form className={classes.Form}>
        {formElementArray.map((formElement, index) => (
          <div className={[
            classes.InputContainer,
            index % 2 === 0 ? classes.InputContainerEven : ''
          ].join(' ')} key={formElement.id}>
            <Input
              value={formElement.config.value}
              key={formElement.id}
              label={formElement.config.label}
              elementType={formElement.config.elementType}
              elementConfig={formElement.config.elementConfig}
              validationObj={formElement.config.validation}
              changed={(event) => this.inputChangeHandler(event, formElement.id)}
              touched={formElement.config.touched}
              focused={formElement.config.isOnFocus}
              invalid={!formElement.config.valid}
              translations={this.props.translations}
              setReference={r => {
                if (formElement.id === 'phone') {
                  this.inputPhoneReference = r;
                }
              }}
            />
          </div>
        ))}
      </form>
    );

    let resumeText = this.props.translations.label_recap_booking
      .replace('{0}', this.props.people + ' ' + (this.props.people > 0 ? this.props.translations.label_people : this.props.translations.label_person))
      .replace('{1}', (this.props.isServiceSelectedEvening ? this.props.translations.label_dinner : this.props.translations.label_lunch).toLowerCase())
      .replace('{2}', parseDateToReadable(this.props.date, this.props.translations))
      .replace('{3}', this.props.time)

    return (
      <Aux>
        <p className={globalClasses.PageTitle}>{this.props.translations.label_complete_data}</p>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <div className={classes.MainContainer}>
            <p className={classes.TextRecapBooking} dangerouslySetInnerHTML={{ __html: resumeText }}></p>
            <div className={classes.FormContainer}>
              {form}

              <p className={classes.Text}>{this.props.translations.label_optional_text}</p>
              <Input
                elementType="textarea"
                value={this.state.specialRequests}
                changed={e => this.setState({ specialRequests: e.target.value })}
              />

              <SquaredCheckbox
                label={<p className={classes.Text}>
                  {this.props.translations.label_privacy_booking_first}
                  <a className={classes.PrivacyPolicyLink} href="https://www.temakinho.com/pages/informativa-privacy-marketing" target="_blank" rel="noopener noreferrer"> {this.props.translations.label_privacy_booking_policy}</a>
                  {this.props.translations.label_direct_marketing}
                </p>}
                clicked={() => this.setState({ hasAcceptedMarketing: !this.state.hasAcceptedMarketing })}
                isChecked={this.state.hasAcceptedMarketing}
              />

              <p className={classes.SmallText}>
                {this.props.translations.label_direct_marketing_complete} <a className={classes.EmailPrivacy} href="mailto:privacy@temakinho.com">privacy@temakinho.com</a>
              </p>

            </div>
          </div>
        </div>

        <Footer
          continueDisabled={!this.checkValidatyAllForm().isValid}
          continueLbl={this.props.translations.label_confirm_booking}
          backClick={this.backHandler}
          nextClick={this.continueHandler} />
      </Aux>
    )
  }
};

const mapStateToProps = state => {
  return {
    restaurantId: state.storeReducer.storeId,
    restaurantName: state.storeReducer.storeName,
    people: state.bookingProcessReducer.numberOfPeople,
    time: state.bookingProcessReducer.timeSelected,
    day: state.bookingProcessReducer.dateSelected,
    menu: state.bookingProcessReducer.promotionSelected,
    translations: state.settingsReducer.translations,
    isServiceSelectedEvening: state.bookingProcessReducer.isServiceSelectedEvening,
    date: state.bookingProcessReducer.dateSelected,

    name: state.bookingProcessReducer.name,
    surname: state.bookingProcessReducer.surname,
    email: state.bookingProcessReducer.email,
    mobilePhone: state.bookingProcessReducer.mobilePhone,
    mobilePhoneCountryData: state.bookingProcessReducer.mobilePhoneCountryData,
    specialRequests: state.bookingProcessReducer.specialRequests,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setPersonalDataFields: fields => dispatch(personalDataSetFields(fields)),
    startBookingConfirmationProcess: () => dispatch(startBookingConfirmationProcess()),
    bookingProcessSetStep: () => dispatch(bookingProcessSetStep(BOOKING_STEPS.PERSONAL_DATA)),
    onNextStep: () => { },
    onBackStep: () => { },
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PersonalDataForm));


// WEBPACK FOOTER //
// ./src/containers/PersonalDataForm/PersonalDataForm.js